// extracted by mini-css-extract-plugin
module.exports = {"root":"AddEditSingleClass_root__2_wgx","selector":"AddEditSingleClass_selector__X5FI9","noData":"AddEditSingleClass_noData__37A3w"};